import * as React from 'react';
import * as vars from '../../../consts/variables';
import loadable from '@loadable/component';

const CustomSelect = loadable(() => import('../../../components/CustomSelect/CustomSelect'));

const styles: Record<string, React.CSSProperties> = {
    flag: {
        width: '15px',
        height: '15px',
        marginRight: '5px',
    },
    option: {
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        minHeight: '100%',
    },
};

interface IOptionProp {
    option: IValue;
    onSelect(IValue): void;
}

class OptionComponent extends React.Component<IOptionProp, {}> {
    constructor(props) {
        super(props);
    }

    handleClick = () => this.props.onSelect(this.props.option);

    render() {
        return (
            <div onClick={this.handleClick} style={styles.option}>
                {this.props.option.icon && (
                    <span>
                        <img style={styles.flag} src={this.props.option.icon} />
                    </span>
                )}
                <span>{this.props.option.label}</span>
            </div>
        );
    }
}

function ValueComponent(props) {
    return (
        <div style={styles.option}>
            {props.value.icon && (
                <img style={styles.flag} src={props.value.icon} height={15} width={15} />
            )}
            <span>{props.value.label}</span>
        </div>
    );
}

interface IValue {
    value: string;
    label?: string;
    icon?: string;
}

interface IProps {
    className?: string;
    options: IValue[];
    value: IValue;
    onChange(value: IValue);
    placeholder: string;
    isError: boolean;
    testSelectorName?: string;
    muiStyling?: boolean;
}

export function CountryCodeSelect(props: IProps) {
    return (
        <CustomSelect
            className={props.className}
            value={props.value}
            valueComponent={ValueComponent}
            options={props.options}
            optionComponent={OptionComponent}
            onChange={props.onChange}
            clearable={false}
            searchable={false}
            placeholder={props.placeholder}
            testSelectorName={props.testSelectorName}
        />
    );
}
